import { IState } from '../../../../../store/types';
import { connect } from 'react-redux';
import { IMyLibRecordingsEvents, IMyLibRecordingsFields } from '../components/types';
import { MyLibRecordingsEvents } from './events';
import { MyLibRecordings } from '../components/MyLibRecordings';
import { getMeParticipantSelector, getRecordingsLangMapSelector } from './selectors';
import { getNativeLanguage, isUserGroupsLoaded } from '../../../../../store/models/selectors';
import { getGeneralStorage } from '../../../../../../common/utils/local-storage/local-storage-helpers';

const mapStateToProps = (
) => {
	return (
		state: IState
	): IMyLibRecordingsFields => {

		const groups = getRecordingsLangMapSelector(state);
		const isLoading = !isUserGroupsLoaded(state);

		return {
			groups,
			isLoading,
			me: getMeParticipantSelector(state),
			nativeLang: getNativeLanguage(state),
			showNativeInitial: !!getGeneralStorage().getData().recordingsShowNative,
		};
	};
}

const mapDispatchToProps = (
	dispatch: any
): IMyLibRecordingsEvents => ({
	onShowNativeChange: (showNative) => dispatch(MyLibRecordingsEvents.onShowNativeChange(showNative)),
	onClick: (groupId, id) => dispatch(MyLibRecordingsEvents.onClick(groupId, id)),
	onDelete: (groupId, id) => dispatch(MyLibRecordingsEvents.onDelete(groupId, id)),
	onDeleteAudio: (groupId, id) => dispatch(MyLibRecordingsEvents.onDeleteAudio(groupId, id)),
	onDeleteVideo: (groupId, id) => dispatch(MyLibRecordingsEvents.onDeleteVideo(groupId, id)),
	onDeleteVideoAndAudio: (groupId, id) => dispatch(MyLibRecordingsEvents.onDeleteVideoAndAudio(groupId, id)),
	onDeleteForEveryone: (id) => dispatch(MyLibRecordingsEvents.onDeleteForEveryone(id)),
	onDownload: (id) => dispatch(MyLibRecordingsEvents.onDownload(id)),
	onDownloadCaptions: (id) => dispatch(MyLibRecordingsEvents.onDownloadCaptions(id)),
	onDownloadCaptionsWithTimecodes: (id) => dispatch(MyLibRecordingsEvents.onDownloadCaptionsWithTimecodes(id)),
	onCreateBook: (id) => dispatch(MyLibRecordingsEvents.onCreateBook(id)),
	onOpenBook: (id) => dispatch(MyLibRecordingsEvents.onOpenBook(id)),
	onOpenExercises: (id) => dispatch(MyLibRecordingsEvents.onOpenExercises(id)),
	onReprocess: (id, force, steps) => dispatch(MyLibRecordingsEvents.onReprocess(id, force, steps)),
	onProcess: (id) => dispatch(MyLibRecordingsEvents.onProcess(id)),
	onCancel: (id) => dispatch(MyLibRecordingsEvents.onCancel(id)),
	onCloseSettings: (id) => dispatch(MyLibRecordingsEvents.onCloseSettings(id)),
});

export const MyLibRecordingsHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(MyLibRecordings);

MyLibRecordingsHOC.displayName = 'MyLibRecordingsHOC';
